/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import GridLoadingSpinner from "../components/GridLoadingSpinner/GridLoadingSpinner";
import { getAllowedOperations } from "../utils/authUtils";

const PrivateRoute = ({
  component: Component,
  componentProps,
  resource,
  operation,
  children,
  isAuthenticated,
  user,
  authPolicies,
  ...rest
}) => {
  const [isGivenOperationAllowed, setIsGivenOperationAllowed] = useState(false);
  const [loading, setLoading] = useState(false);


  const renderComponents = () => {
    if (Component) return <Component {...componentProps} />;
    return children;
  };
  return (
    loading ? <div
      style={{
        margin: "40vh auto",
        height: "20vh",
        width: "20vh",
        textAlign: "center",
      }}
    >
      <GridLoadingSpinner />
    </div> :
      <Route
        {...rest}
        render={() =>
          // eslint-disable-next-line no-nested-ternary
         isAuthenticated ? (
              renderComponents()
            )  : (
            <div
              style={{
                margin: "40vh auto",
                height: "20vh",
                width: "20vh",
                textAlign: "center",
              }}
            >
              {/* <GridLoadingSpinner /> */}
            </div>
          )
        }
      />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  componentProps: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  authPolicies: PropTypes.arrayOf(
    PropTypes.shape({
      denied: PropTypes.arrayOf(PropTypes.string).isRequired,
      allowed: PropTypes.arrayOf(PropTypes.string).isRequired,
      resourceGroup: PropTypes.string.isRequired,
      operation: PropTypes.string.isRequired,
    })
  ).isRequired,
  resource: PropTypes.string,
  operation: PropTypes.string,
  children: PropTypes.node,
};

PrivateRoute.defaultProps = {
  componentProps: {},
};

export default connect(({ auth }) => ({
  isAuthenticated: auth.isAuthenticated,
  user: auth.user,
  authPolicies: auth.authPolicies,
}))(PrivateRoute);
